export default __webpack_public_path__ + "static/media/Pagenotfound.b561ece8.svg";